import React from "react";
import PropTypes from "prop-types";

export default function AddUser(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51.5454 0C54.1776 0 56.6934 0.512323 59 1.44331C59 10.8398 59 26.5388 59 39.1622C56.6934 40.0931 54.1776 40.6055 51.5454 40.6055C40.4472 40.6055 31.4182 31.4977 31.4182 20.3027C31.4182 9.10781 40.4472 0 51.5454 0Z"
        fill={props.fill}
      />
      <path
        d="M26.5032 53.8692C32.0136 48.2253 39.3186 45.1172 47.0727 45.1172H56.0181C57.0205 45.1172 57.8818 45.1172 59 45.1172C58.9995 57.0347 59.0002 68.7767 59 77H20.2364C19.0013 77 18 75.99 18 74.7441C18 66.8987 21.0198 59.4854 26.5032 53.8692Z"
        fill={props.fill}
      />
      <path
        d="M8.53125 30C8.53125 29.4477 8.97896 29 9.53125 29H11.4688C12.021 29 12.4688 29.4477 12.4688 30V37.5312H20C20.5523 37.5312 21 37.979 21 38.5312V40.4688C21 41.021 20.5523 41.4688 20 41.4688H12.4688V49C12.4688 49.5523 12.021 50 11.4688 50H9.53125C8.97897 50 8.53125 49.5523 8.53125 49V41.4688H1C0.447716 41.4688 0 41.021 0 40.4688V38.5312C0 37.979 0.447716 37.5312 1 37.5312H8.53125V30Z"
        fill={props.fill}
      />
    </svg>
  );
}

AddUser.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
AddUser.defaultProps = {
  className: "",
  fill: "#E9F1FE",
  width: 59,
  height: 77
};
